import { connect } from 'react-redux';
import { compose } from 'redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { breedRelationsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import BreederProfileRelatedBreedsList from 'dpl/components/BreederProfile/Index/BreederProfileRelatedBreedsList';

export default compose(
  __DEPRECATED_defineResources(({ server, queryParams }) => {
    const {
      breeds = [{}],
      citySlug = '',
      preappliedFilters,
      nonStandard
    } = server;
    // This component is in use on breeder search pages and breeder profile pages
    // server.breedId is for searches, queryParams.breed_id & breeds[0].id for profiles
    const breedId = server.breedId || queryParams.breed_id || breeds[0]?.id;
    const stateSlug = preappliedFilters
      ? preappliedFilters.stateSlug
      : server.stateSlug;

    return {
      breedRelationsData: {
        ...breedRelationsResourceDefinition(
          breedId,
          nonStandard,
          citySlug,
          stateSlug
        ),
        auto: Boolean(breedId)
      }
    };
  }),
  connect(({ server }, { breedRelationsData }) => ({
    currentBreedId: Number(server.breedId),
    relatedBreeds: breedRelationsData.value.data
  }))
)(BreederProfileRelatedBreedsList);
